import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
type FaqItemProps = {
  q: string;
  a: string;
};
export function FaqItem({
  q,
  a
}: FaqItemProps) {
  const [open, setOpen] = useState(false);
  return <div className="border-b border-line" data-id="element-121" data-mp="1r0v18kx1drcn">
      <h3 data-id="element-122" data-mp="1qzte3i2qxeek">
        <button type="button" onClick={() => setOpen(o => !o)} aria-expanded={open} className="flex w-full items-start justify-between gap-4 py-5 text-left text-base font-bold text-white transition-colors duration-150 hover:text-volt focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-spark sm:text-lg" data-id="element-123" data-mp="1qzjuqdc7i5hu">
          {q}
          <PlusIcon className={`mt-0.5 h-6 w-6 shrink-0 text-volt transition-transform duration-200 ease-out ${open ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-124" data-mp="1831vlav133bk" />
        </button>
      </h3>
      <AnimatePresence initial={false} data-id="element-125" data-mp="32fi1gajwwffw">
        {open && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} className="overflow-hidden" data-id="element-126" data-mp="101uuod2kcfql">
            <p className="pb-5 text-base leading-relaxed text-mist" data-id="element-127" data-mp="14skw5f7vbyg0">{a}</p>
          </motion.div>}
      </AnimatePresence>
    </div>;
}